import { BasicModularNavBarTemplate } from "src/components/ModularNavBar";
import useDevice from "src/hooks/useDevice";
import DynamicSelectButton from "./DynamicSelectButton";

const SelectModeGatheringHomeNavBarContent = () => {
	const { device } = useDevice();
	return (
		<BasicModularNavBarTemplate
			includeLogo={device === "desktop"}
			items={[DynamicSelectButton]}
		/>
	);
};
export default SelectModeGatheringHomeNavBarContent;
